import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StudentAssignmentDetailsModel } from 'common/models/page-models/Student Assignment/Student Assignment Details/student-assignment-details-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentAssignmentDetailsWidgetService } from 'common/widget/Student Assignment Details/student-assignment-details-widget.service';

 
@Injectable({
    providedIn: 'root'
})
export class StudentAssignmentDetailsResolver extends FormResolverService<StudentAssignmentDetailsModel> {
    constructor(
        protected fs: StudentAssignmentDetailsWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    // studentfeedback

    override modifyResponseData(dataModel, meta, widget) {
      
        dataModel['pageKey']=widget.transferData.transferData.type
        dataModel['studentfeedback'] = '';
        return dataModel;
    }
}